// Function index:
//   HORSE — mount silhouette; `saddle` is where a rider body's ground line
//       sits (the composer scales the rider ~0.8 onto it).
//   WAGON — party prop parked at the party edge of the line.
// Both in 0 0 width 60 boxes, ground y=60, facing right, currentColor only.

import type { PartDef } from './types.js';

export const HORSE: PartDef & { saddle: { x: number; y: number } } = {
  width: 56,
  saddle: { x: 26, y: 30 },
  svg: '<ellipse cx="28" cy="38" rx="20" ry="9" fill="currentColor"/>' +
    '<path d="M44 34 q8 -8 6 -16 l-5 3 q-4 6 -6 9 Z" fill="currentColor"/>' +
    '<line x1="16" y1="44" x2="14" y2="60" stroke="currentColor" stroke-width="3.5"/>' +
    '<line x1="24" y1="46" x2="24" y2="60" stroke="currentColor" stroke-width="3.5"/>' +
    '<line x1="34" y1="46" x2="36" y2="60" stroke="currentColor" stroke-width="3.5"/>' +
    '<line x1="40" y1="44" x2="43" y2="60" stroke="currentColor" stroke-width="3.5"/>' +
    '<path d="M10 42 q-6 2 -8 8" stroke="currentColor" stroke-width="2.5" fill="none"/>',
};

export const WAGON: PartDef = {
  width: 52,
  svg: '<rect x="4" y="30" width="42" height="18" rx="3" fill="currentColor"/>' +
    '<path d="M4 30 Q25 16 46 30 Z" fill="currentColor"/>' +
    '<circle cx="14" cy="52" r="7" fill="none" stroke="currentColor" stroke-width="3"/>' +
    '<circle cx="36" cy="52" r="7" fill="none" stroke="currentColor" stroke-width="3"/>',
};
